var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{on:{"close":_vm.onModalClose}},[_c('login-form',{attrs:{"is-open":"","submit-button-type":"normal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }